import { Box, Button, Grid, Modal, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useTheme } from '@mui/styles'
import React from 'react'
import { TextRegular } from '../../../../commonComponents/TextStyling'
import { ENV } from '../../../../ENV'
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 5,
  p: 2
}

export default function NeedHelpModal ({ data, handleRTREmail, loading }) {
  var { open, item, onClose } = data
  const theme = useTheme()
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <CloseIcon
          onClick={onClose}
          style={{
            position: 'absolute',
            right: 4,
            top: 4,
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
            borderRadius: 20,
            fontSize: '24px',
            cursor: 'pointer'
          }}
        />
        <Typography
          id='modal-modal-description'
          sx={{ m: 5 }}
          style={{ whiteSpace: 'pre-line' }}
        >
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextRegular>
                We recommend advising candidates to approve a right-to-represent
                request before resending it.
              </TextRegular>
            </Grid>
            <Grid item xs={12}>
              <TextRegular>
                If you have already followed up with your candidate about
                approving your right-to-represent request, then please follow
                these three steps:
              </TextRegular>
            </Grid>
            <ul>
              <li>
                <Grid item xs={12}>
                  <TextRegular>
                    Ensure that {item?.candidateFirstName}{' '}
                    {item?.candidateLastName}'s email address is{' '}
                    {item?.candidateEmail}.
                  </TextRegular>
                </Grid>
              </li>
              <li>
                <Grid item xs={12}>
                  <TextRegular>
                    Confirm that the candidate checked their secondary email
                    folders like the junk and spam folders.
                  </TextRegular>
                </Grid>
              </li>
              <li>
                <Grid item xs={12}>
                  <TextRegular>
                    You can resend a right-to-represent request by clicking the
                    “Resend RTR email” button below. For further assistance,
                    please reach out to us at{' '}
                    <span style={{ color: theme.palette.primary.main }}>
                      {ENV.product_mail}.
                    </span>
                  </TextRegular>
                </Grid>
              </li>
            </ul>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <Button
                variant='contained'
                onClick={() => {
                  handleRTREmail()
                  onClose()
                }}
                style={{ textTransform: 'none', marginTop: 10 }}
              >
                Resend RTR email
              </Button>
            </Grid>
          </Grid>
        </Typography>
      </Box>
    </Modal>
  )
}
